/**
*@title 엑스포 영상, 문의처, 엑스포 구성 요소
*@date 2022-02-07
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import {Link} from 'react-router-dom';

import '../../css/main.css';
import '../../css/reset.css';
import '../../css/top-menu.css';

import Footer from '../Footer';
import BoothMap from './BoothMap';


import top_img from '../../images_front/sub_page_exhibitor.svg'
import top_img_en from '../../images_front/sub_page_exhibitor_en.svg'
import prepare_img from '../../images/prepare_image.png';


import { t } from 'i18next';

class company extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            scrollY: 0,
        }
        this.scrollHandler = this.scrollHandler.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll',this.scrollHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll',this.scrollHandler);
    }

    scrollHandler = () => {
        this.setState({scrollY:window.pageYOffset})
        // console.log(this.state.scrollY);
    }
    render () {
        return(
            <div>
                <div className='visitor-top-section-wrap'>
                    {
                        t("lang") == "ko"
                        ? <img src={top_img}/>
                        : <img src={top_img_en}/>
                    }
                </div>
                <div className="cnt-section-wrap-5">
                    <div>
                        <ul>
                            <li>
                                <div className="cont-btn-submenu-clicked">
                                    <Link to="/exhibitor/boothmap">{t("header_comp_booth")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/exhibitor/company">{t("header_comp_intro")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/exhibitor/overview">{t("header_comp_ask")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/exhibitor/companysponsor">{t("header_comp_sponsor")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/exhibitor/venture_capital">{t("header_comp_venture")}</Link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='cnt-section-wrap-subpages'>
                    <BoothMap/>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default company;